import React from 'react';
import Table from '../../common/TableOverView';
import { connect } from 'react-redux';
import { REDUCER_NAME, changeSortState } from '../reducer';
import Const from './Const';

const getDataFromRedux = state =>
  state[REDUCER_NAME].listObjectDataTopNewHighByTicker;

function TableOverViewNewHigh(props) {
  const { listId, isLoading, sortState, changeSortState } = props;
  return (
    <Table
      onSort={changeSortState}
      sortState={sortState}
      listId={listId}
      isLoading={isLoading}
      resizable={true}
      columnDraggable={false}
      rowDraggable={false}
      getDataFromRedux={getDataFromRedux}
      hideColumns={Const.listHideColumn}
      listColumns={Const.listColumn}
      i18nTitleKey="topVolume.overview.overviewTopNewHighHeader"
    />
  );
}

const mapStateToProps = state => {
  return {
    listId: state[REDUCER_NAME].listDataTopNewHighTicker,
    isLoading: state[REDUCER_NAME].isLoading,
    sortState: state[REDUCER_NAME].sortState,
  };
};

const mapDispatchToProps = {
  changeSortState,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(TableOverViewNewHigh);
